import React, { useEffect, useState } from "react";
import "./ServiceProvidersSection.scss";
import ContentSection from "../components/ContentSection";
import SectionHeader from "../components/SectionHeader";
import StatBlock from "../components/StatBlock";
import ThickBarChart from "../components/ThickBarChart";
import { DonutChart } from "../components";

const ServiceProvidersSection: React.FC = () => {
  const [chartWidth, setChartWidth] = useState(624);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 480) {
        setChartWidth(300);
      } else if (width <= 768) {
        setChartWidth(500);
      } else {
        setChartWidth(624);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <ContentSection className="service-providers-section">
      <div className="service-providers-section-content">
        <SectionHeader
          title="Federal Funding Disruptions:Service Providers"
          description="The field is facing stark challenges but meeting them with resilience."
        />
        <p className="service-providers-content-description">
          Among organizations that experienced cancelled or delayed federal
          contracts in 2025, 29% reported having to lay off staff to adjust to
          reduced budgets This underscores that the field now operates with
          reduced capacity. Federal funding represents a significant portion of
          operating budgets for many.
        </p>
        <DonutChart
          title="Impact of cancelled or delayed Federal contracts"
          subtitle="Organizations that had to lay off staff due to reduced budgets"
          data={[
            { label: "Laid off staff", percentage: 29, color: "#16B19B" },
            { label: "No staff layoffs", percentage: 71, color: "#89C340" },
          ]}
        />

        <div className="service-providers-two-col-stats">
          <StatBlock
            stat={21}
            statLabel="%"
            label="Respondents indicated that funding delays or cancellations have affected the services they provide in their communities"
          />
          <StatBlock
            statPrefix="$"
            stat={24}
            statLabel=" -26 million"
            label={
              "Approximate total funding reported not received due to canceled or delayed Federal contracts in 2025, leading to losses in community investments"
            }
          />
        </div>

        {/* Removed second donut per request */}

        <p className="service-providers-content-description">
          Even with these challenges, 64% of respondents expressed optimism
          about their ability to provide reentry workforce services over the
          next 18 months, though that figure drops to 42% when looking out over
          the next five years. This shift reflects both the adaptability of
          providers and the uncertainty they face in a changing federal funding
          environment. Research has shown that when dedicated funding sources
          are disrupted, smaller community-based organizations, often the ones
          closest to the populations they serve, are disproportionately
          impacted. Reduced staffing capacity not only affects the number of
          individuals served, but also the depth of services provided. 
        </p>

        <ThickBarChart
          title="Service delivery confidence"
          subtitle="Optimism about ability to provide reentry workforce services"
          data={[
            {
              label: "Next 18 months",
              value: 64,
              color: "#FF8C42", // orange
            },
            {
              label: "Next 5 years",
              value: 42,
              color: "#84C141", // lime green
            },
          ]}
          width={chartWidth}
          height={300}
          maxValue={80}
          className="responsive-chart"
        />

        <p className="service-providers-content-description">
          Intermediaries that provide capacity building and administrative help
          are sometime used to support networks for smaller organizations. These
          organizations can serve as strategic partners to support the long-term
          viability of smaller organizations and facilitate rapid release of
          funding in times of crisis.
        </p>
      </div>
    </ContentSection>
  );
};

export default ServiceProvidersSection;
